import React, { useContext } from 'react';
import ddt from '@wix/da-ddt';
import { ReferralType, BiEventType, BiDataHook, } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useVerification } from '../../../../VerificationPopup/withVerification';
import { generateReplyEditorId } from '../../../utils';
import { CommentContext } from '../../../CommentContext';
var getReplyToParam = function () {
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.location.search) {
        return;
    }
    var params = new URLSearchParams(window.location.search);
    var replyTo = Number(params.get('reply_to'));
    return replyTo;
};
var ReplyButton = function (_a) {
    var className = _a.className, disabled = _a.disabled, children = _a.children, focusEditor = _a.focusEditor, restrictLoggedOut = _a.restrictLoggedOut;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _b = useContext(CommentContext), comment = _b.comment, isReplying = _b.isReplying, setEditingState = _b.setEditingState;
    var restrictToVerified = useVerification().restrictToVerified;
    var logBiEvent = useBiLogger();
    var onClickReply = restrictToVerified('comment', function () {
        var _a;
        if (!isLoggedIn) {
            restrictLoggedOut({ restrictedActionName: ReferralType.COMMENT });
            return;
        }
        if (!isReplying) {
            // if arrived with reply_to param, we already logged this event in the trigger
            var withBiEvent = !getReplyToParam();
            if (withBiEvent) {
                logBiEvent({
                    evid: BiEventType.CLICK_REPLY_TO_COMMENT,
                    commenterid: (_a = comment.user) === null || _a === void 0 ? void 0 : _a.useridUuid,
                    commentid: comment.commentId,
                    typeid: comment.typeId,
                    itemid: comment.itemId,
                });
            }
        }
        ddt.log('comments', 'Replying on comment, editorId: ', generateReplyEditorId(comment));
        setEditingState(isReplying ? 'none' : 'replying');
        focusEditor(generateReplyEditorId(comment));
    });
    return (React.createElement(PlainButtonOrLink, { className: className, onClick: onClickReply, "data-hook": BiDataHook.COMMENT_REPLY_BUTTON, disabled: disabled }, children));
};
ReplyButton.displayName = 'ReplyButton';
export default ReplyButton;
//# sourceMappingURL=ReplyButton.js.map